
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
import { Heading } from '@/components/Heading'
import { TipGood, TipBad } from '@/components/Tip'
import { CodeSample } from '@/components/CodeSample'
const Layout = _Layout;
const meta = {
  "id": "promotion",
  "title": "Promotion",
  "sidebar_label": "Promotion"
};
const slug = 'promotion';
const tableOfContents = [{
  "title": "Creating Promotions",
  "slug": "creating-promotions",
  "children": []
}, {
  "title": "Promo Banners in Admin",
  "slug": "promo-banners-in-admin",
  "children": []
}, {
  "title": "Banner Placement",
  "slug": "banner-placement",
  "children": []
}, {
  "title": "Banner Destination",
  "slug": "banner-destination",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">







    <p><a parentName="p" {...{
        "href": "https://developer.tradly.app/#afed06fb-a843-43d3-a350-cab722ef9968"
      }}>{`API REFERENCE`}</a>{`| `}<a parentName="p" {...{
        "href": "https://superadmin.tradly.app/promotions"
      }}>{`Promotion in SuperAdmin`}</a></p>
    <p>{`Promotions are banners and videos placed in strategic locations to attract attention and promote a particular product, service, or message. `}</p>
    <p>{`In Tradly, promotions can be directed towards a listing, an account, an external link, or a static message. `}</p>
 <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/promotion1.png" />
      </div>
    <_Heading level={2} id={"creating-promotions"} nextElement={{
      "type": "paragraph"
    }}>Creating Promotions</_Heading>
    <p>{`To create a promotion, you can use the following options:`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Destination: Choose where you want the promotion to link to (e.g. a listing, an account, an external link, or a static message)`}</li>
      <li parentName="ul">{`Schedules: Choose when you want the promotion to start and end`}</li>
      <li parentName="ul">{`Placement type: Choose where you want the promotion to be placed (e.g. on the homepage, in a particular section)`}</li>
      <li parentName="ul">{`Channel: Choose which channel you want the promotion to run on (e.g. web or app)`}</li>
    </ul>
    <_Heading level={2} id={"promo-banners-in-admin"} nextElement={{
      "type": "paragraph"
    }}>Promo Banners in Admin</_Heading>
    <p>{`As a platform owner, you can use the media section to display promotional materials in prime locations. This could be used to promote important promotions, provide how-to guides, explain features, promote specific products, advertise placements, or direct users to a particular tag (a group of listings).`}</p>
    <p>{`To add banners:`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Give the banner a name (we recommend using a naming convention like “month_campaigntype_optionalnote” for easy analysis and tracking in the future)`}</li>
      <li parentName="ul">{`Upload an image and crop it as needed`}</li>
      <li parentName="ul">{`Choose the target destination for the banner`}</li>
      <li parentName="ul">{`Set the start and end dates for the banner using the schedules`}</li>
      <li parentName="ul">{`Activate or deactivate the banner using the status function`}</li>
    </ul>
    <_Heading level={2} id={"banner-placement"} nextElement={{
      "type": "paragraph"
    }}>Banner Placement</_Heading>
    <p>{`You can upload different banners for mobile and web applications with different dimensions and settings. `}</p>
    <p>{`Mobile banner size: 1280 x 720 (the same size you would use for creating Facebook ads on Canva or other platforms)`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`The app will automatically resize the banner to fit the mobile screen, taking up approximately 80% of the space (excluding padding and card UI)`}</li>
    </ul>
    <_Heading level={2} id={"banner-destination"} nextElement={{
      "type": "paragraph"
    }}>Banner Destination</_Heading>
    <p>{`Banners can be configured for different actions. `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Static banners: Use banners as informational or promotional banners`}</li>
      <li parentName="ul">{`Listing banners: Use banners to promote a particular listing (we recommend including a call-to-action button to differentiate these banners)`}</li>
    </ul>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
